export default "/assets/website/images/chev-next.svg?67f4133358b60382cc9974d40b16a5bf";